import {readCookie} from './cookieUtils';

function getAgeData() {
    const CHILDREN_AGE_COOKIE = 'ha-children-age-prst';
    const childrenAgesCookieData = readCookie(CHILDREN_AGE_COOKIE);

    if (childrenAgesCookieData && childrenAgesCookieData.childrenAges) {
        return childrenAgesCookieData.childrenAges.map((age) => ({
            value: age
        }));
    }
    return [];
}

export {getAgeData};
